import dynamic from 'next/dynamic';
import { useState } from 'react';

import { InfoOutline } from '@/core/tamagoshi/icons/InfoOutline';
import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { Label } from '@/domains/core/tamagoshiTailwind/components/Label/Label';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { StringAbTests } from '@/domains/productDiscovery/ProductPage/constants';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import type { SecondHandProductConditionModalProps } from '@/domains/sustainability/secondHand/components/SecondHandProductConditionTag/SecondHandProductConditionModal/SecondHandProductConditionModal';
import {
  conditionTranslations,
  contextTranslations,
} from '@/domains/sustainability/secondHand/translations';
import { CLICK_ON_PRODUCT_CONDITION_TAG } from '@/domains/sustainability/secondHand/utils/gtmUtils';

import styles from './SecondHandProductConditionTag.module.scss';

const DynamicSecondHandProductConditionModal =
  dynamic<SecondHandProductConditionModalProps>(() =>
    import(
      '@/domains/sustainability/secondHand/components/SecondHandProductConditionTag/SecondHandProductConditionModal/SecondHandProductConditionModal'
    ).then((imports) => imports.SecondHandProductConditionModal),
  );

export const SecondHandProductConditionTag = () => {
  const { secondHandDetails } = useDetail();
  const [modalDisplayed, setModalDisplayed] = useState(false);

  const [isProductPageRevampEnabled] = useBooleanFlags([
    StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP,
  ]);

  if (!secondHandDetails) {
    return null;
  }
  const { context, productCondition } = secondHandDetails;
  const tagValue = productCondition
    ? `${contextTranslations[context]} ${conditionTranslations[productCondition]}`
    : contextTranslations[context];

  const showModal = () => {
    Gtm.push(CLICK_ON_PRODUCT_CONDITION_TAG(tagValue));
    setModalDisplayed(true);
  };
  const hideModal = () => {
    setModalDisplayed(false);
  };
  return (
    <>
      {isProductPageRevampEnabled ? (
        <div className="flex items-center">
          <Label text={tagValue} variant="SuccessPrimary" />
          <InfoOutline
            height={16}
            width={16}
            onClick={showModal}
            className="cursor-pointer"
          />
        </div>
      ) : (
        <button
          type="button"
          className={styles.secondHandCondition}
          onClick={showModal}
        >
          {tagValue} <InfoOutline height={16} width={16} />
        </button>
      )}
      {modalDisplayed && (
        <DynamicSecondHandProductConditionModal
          title={tagValue}
          secondHandDetails={secondHandDetails}
          hideModal={hideModal}
        />
      )}
    </>
  );
};
